import React, {useMemo} from 'react';
import type {BoxProps} from '@tempo/core';
import {Tr} from '@tempo/core';
import {useTableContext} from '@components/Table';

type RowProps = {
	children: React.ReactNode;
	index?: number;
	isClickable?: boolean;
	['data-testid']?: string;
} & BoxProps;

const Row = ({
	children,
	index,
	sx,
	isClickable,
	['data-testid']: dataTestId,
	...rest
}: RowProps) => {
	const {size, variant} = useTableContext();

	const minHeight = useMemo(() => {
		switch (size) {
			case 'sm':
				return 12;
			case 'lg':
				return 16;
			case 'md':
			default:
				return 14;
		}
	}, [size]);

	return (
		<Tr
			borderRadius="xl"
			height={minHeight}
			role="group"
			sx={sx}
			{...(isClickable
				? {
						cursor: 'pointer',
						_hover: {
							bg:
								variant === 'onContent'
									? 'background.neutral.tertiary.hovered'
									: 'background.neutral.primary.hovered',
						},
					}
				: {})}
			data-testid={dataTestId || `table-row-${index}`}
			{...rest}
		>
			{children}
		</Tr>
	);
};

export default Row;
